import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { AgitationSection, WhoIsItFor, FAQSection, FinalCTA, Footer, PriceAnchorSection } from './shared_components';
import { SocialProofSection } from './components/SocialProofSection';
import { OfferSection } from './components/OfferSection';
import { IndividualProducts } from './components/IndividualProducts';
import { GuaranteeSection } from './components/GuaranteeSection';
import { WhatsAppButton } from './WhatsAppButton';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48566694772993:1';
export function App() {
  const [showFloat, setShowFloat] = useState(false);
  // Meta Pixel
  useEffect(() => {
    const PIXEL_IDS = ['2344220106105382', '1663859418293777'];
    const w = window as any;
    // 1. Inicializar fbq stub
    if (!w.fbq) {
      const n: any = w.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
    }
    // 2. Inyectar script en <head>
    if (!document.querySelector('script[src*="fbevents.js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    // 3. Inyectar noscript pixel images (requerido por Pixel Helper)
    PIXEL_IDS.forEach(id => {
      if (!document.querySelector(`img[src*="id=${id}"]`)) {
        const img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        img.src = `https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`;
        document.body.appendChild(img);
      }
    });
    // 4. Init ambos pixels + PageView
    PIXEL_IDS.forEach(id => w.fbq('init', id));
    w.fbq('track', 'PageView');
  }, []);
  useEffect(() => {
    const fn = () => setShowFloat(window.scrollY > 700);
    window.addEventListener('scroll', fn, {
      passive: true
    });
    return () => window.removeEventListener('scroll', fn);
  }, []);
  return <div className="w-full min-h-screen bg-navy-mid font-sans overflow-x-hidden" data-id="element-0">
      <StickyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <AgitationSection data-id="element-4" />
      <SocialProofSection data-id="element-5" />
      <OfferSection data-id="element-6" />
      <PriceAnchorSection data-id="element-7" />
      <IndividualProducts data-id="element-8" />
      <WhoIsItFor data-id="element-9" />

      <FAQSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />

      {/* ── WHATSAPP FLOTANTE ── Siempre visible, sobre todo lo demás */}
      <WhatsAppButton data-id="element-13" />

      {/* ── MOBILE CTA BAR ── Solo en mobile, debajo del WhatsApp */}
      <AnimatePresence data-id="element-14">
        {showFloat && <motion.div initial={{
        y: 90,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 90,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed bottom-0 left-0 right-0 z-40 p-3 bg-navy-dark/95 backdrop-blur-md border-t border-gold/20 md:hidden" style={{
        paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
      }} data-id="element-15">
            <a href={KIT_URL} className="btn-gold block font-display font-bold text-base py-4 rounded-xl text-center no-underline" data-id="element-16">
              Kit Completo — $62.900 →
            </a>
          </motion.div>}
      </AnimatePresence>
    </div>;
}